module.exports = __webpack_public_path__ + "static/media/icon_menu_close.a4bef685.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_menu_close.svg
// module id = 441
// module chunks = 0